<template>
  <!-- 智能推荐或热门职业 -->
  <div id="intelligence_suggest">
    <div class="intelligence_suggest">
      <div class="intelligence_suggest_top">
        <div>{{ title }}</div>
        <div  @click="
                $router.push({
                  name: 'searchCenter',
                  params: {...condition},
                })
              ">
          <span  >更多</span>
          <img src="@/assets/images/jiantou.png" alt="" />
        </div>
      </div>
      <div class="intelligence_suggest_bottom">
        <ul>
          <li
            class="intelligence_suggest_content"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <!-- 职业标题 -->
            <div @click="openOnNewPage('/careerDetail', item.id)">
              <span>{{ item.name }}</span>

              <span>{{ item.salary }}</span>
            </div>
            <!-- 要求标签 -->
            <div @click="openOnNewPage('/careerDetail', item.id)">
              <span>{{ item.city }}</span>
              <span v-if="item.education || item.education == 0">
                {{
                  item.education == -1
                    ? "学历不限"
                    : educationMapping[item.education]
                }}
              </span>
              <span v-if="item.workExperience || item.workExperience == 0">{{
                item.workExperience == -1
                  ? "经验不限"
                  : workExperienceMapping[item.workExperience]
              }}</span>
              <span v-for="(item, index) in item.require" :key="index">{{
                item
              }}</span>
            </div>
            <!-- 公司信息 -->
            <div
              v-if="item.company !== null"
              @click="openOnNewPage('/companyDetail', item.company.id)"
            >
              <img
                v-if="item.company.imageAddress"
                :src="imgUrl + item.company.imageAddress"
                alt=""
              />
              <img v-else src="@/assets/images/company.png" alt="" />
              <div>
                <div>{{ item.company.name }}</div>
                <!-- 公司信息标签 -->
                <div>
                  <span v-if="item.company.industry !== null">{{
                    item.company.industry
                  }}</span>
                  <span v-if="item.company.financeStage !== null">{{
                    financeStageMapping[item.company.financeStage]
                  }}</span>
                  <span v-if="item.company.peopleNumber !== null">{{
                    peopleNumberMapping[item.company.peopleNumber]
                  }}</span>
                </div>
                <!-- 公司地址 -->
                <div>
                  <img src="@/assets/images/address.png" alt="" />
                  <span>{{ item.company.address }}</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["dataList", "title","condition"],
  data() {
    return {
      educationMapping: ["大专", "本科", "硕士", "博士"],
      workExperienceMapping: [
        "应届生",
        "实习生",
        "1年以内",
        "1-3年",
        "3-5年",
        "5-10年",
        "10年以上",
      ],
      peopleNumberMapping: [
        "0-20人",
        "20-99人",
        "100-499人",
        "500-999人",
        "1000-9999人",
        "10000人以上",
      ],
      financeStageMapping: [
        "未融资",
        "天使轮",
        "A轮",
        "B轮",
        "C轮",
        "D轮及以上",
        "已上市",
      ],
    };
  },
  methods: {},
  created() {},
};
</script>

<style scoped>
#intelligence_suggest {
  margin: 10px 0;
}

.intelligence_suggest {
  width: 1200px;
  margin: auto;
}

.intelligence_suggest_top {
  height: 60px;
  background-color: white;
  border: 1px solid #24adde;
}

.intelligence_suggest_top div {
  width: 150px;
}

.intelligence_suggest_top div:nth-child(1) {
  float: left;
  text-align: center;
  line-height: 60px;

  font-size: 30px;
  font-weight: 600;
  color: #000;
}

.intelligence_suggest_top div:nth-child(2) {
  float: right;
  text-align: right;
  line-height: 60px;
  padding-right: 10px;
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.intelligence_suggest_top div:nth-child(2) img {
  margin-left: 2px;
}

.intelligence_suggest_top div:nth-child(2):hover {
  color: #24ade1;
  cursor: pointer;
}

.intelligence_suggest_bottom ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  align-content: space-between;
}

.intelligence_suggest_bottom ul li {
  padding: 15px 15px;
  border-radius: 5px;
  width: 355px;
  margin-bottom: 20px;
  background-color: white;
}

.intelligence_suggest_content > div {
  margin-bottom: 10px;
}

.intelligence_suggest_content > div:nth-child(1) {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.intelligence_suggest_content > div:nth-child(1):hover > span:nth-child(1) {
  color: #24ade1;
}

.intelligence_suggest_content > div:nth-child(1) span:nth-child(1) {
  width: 250px;
  font-size: 18px;
  font-weight: 500;

  color: #000;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.intelligence_suggest_content > div:nth-child(1) span:nth-child(2) {
  font-size: 18px;
  font-weight: 500;
  white-space: nowrap;
  color: #ff6400;
}

.intelligence_suggest_content > div:nth-child(3) {
  background-color: #f7fcfc;
  padding: 10px 5px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.intelligence_suggest_content
  > div:nth-child(3):hover
  > div
  > div:nth-child(1) {
  color: #24ade1;
}

.intelligence_suggest_content > div:nth-child(3) img {
  width: 60px;
  height: 60px;
}

.intelligence_suggest_content > div:nth-child(3) > div {
  padding-left: 10px;
  width: 260px;
  height: 70px;
}

.intelligence_suggest_content > div:nth-child(3) > div > div:nth-child(2) {
  margin: 5px 0;
}

.intelligence_suggest_content > div:nth-child(2) {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.intelligence_suggest_content > div:nth-child(2) span {
  margin-right: 10px;
  background-color: #f8f9fb;
  padding: 3px 8px;
  font-size: 12px;
  font-weight: 400;
  color: #999;
  border-radius: 6px;
}

.intelligence_suggest_content > div:nth-child(3) > div > div:nth-child(1) {
  height: 20px;
  font-size: 14px;
  font-weight: 500;
  color: #666;
}
.intelligence_suggest_content > div:nth-child(3) > div > div:nth-child(2) {
  white-space: nowrap;
  overflow: hidden;

  /* ========================= */
}
.intelligence_suggest_content
  > div:nth-child(3)
  > div
  > div:nth-child(2)
  > span {
  font-size: 12px;
  font-weight: 400;
  color: #999;
  display: inline-block;
  margin-right: 10px;
  max-width: 100px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.intelligence_suggest_content > div:nth-child(3) > div > div:nth-child(3) {
  display: flex;

  align-items: center;
}
.intelligence_suggest_content > div:nth-child(3) > div > div:nth-child(3) img {
  width: 15px;
  height: 15px;
  vertical-align: middle;
}

.intelligence_suggest_content > div:nth-child(3) > div > div:nth-child(3) span {
  font-size: 12px;
  font-weight: 400;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #999999;
}
</style>